import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-primary-400">每日吃瓜</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              聚合全网最热娱乐资讯，实时更新网红博主、明星八卦、聊天记录等内幕爆料。吃瓜不停，精彩不断。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-foreground-400 mb-4 font-medium">热门频道</h4>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-foreground-400 mb-4 font-medium">快速链接</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-foreground-400 mb-4 font-medium">联系我们</h4>
            <ul className="space-y-3 text-sm text-foreground-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                <span>contact@meirichigua.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-line mt-0.5 text-foreground-400"></i>
                <span>商务合作 / 爆料投稿</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 每日吃瓜 meirichigua.com 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>

      <div className="px-4 md:px-6 pb-8">
        <div className="text-center">
          <span className="text-7xl md:text-9xl font-heading font-bold text-foreground-800 select-none opacity-30">
            每日吃瓜
          </span>
        </div>
      </div>
    </footer>
  );
}